import { Box, Text, VStack } from '@chakra-ui/react'
import { getDateTimeRangeString, PracticeVisit, visitTypeNames, WithId } from '@hb/shared'
import { SolidActionButton } from '../../../components/Buttons'

export const VisitPreview = ({
  visit,
  onOpenModal,
}: {
  visit: WithId<PracticeVisit>
  onOpenModal?: () => void
}) => (
  <VStack p={3} align="stretch" spacing={2}>
    <Box>
      <Text fontSize="sm" fontWeight={500} color="gray.600">
        Patient
      </Text>
      <Text fontSize="md">
        {visit.patientFirst} {visit.patientLast}
      </Text>
    </Box>
    <Box>
      <Text fontSize="sm" fontWeight={500} color="gray.600">
        Visit Type
      </Text>
      <Text fontSize="md">{visitTypeNames[visit.type]}</Text>
    </Box>
    <Box>
      <Text fontSize="sm" fontWeight={500} color="gray.600">
        Time
      </Text>
      <Text fontSize="sm">{getDateTimeRangeString(visit.startTime, visit.endTime)}</Text>
    </Box>
    {onOpenModal ? (
      <SolidActionButton size="sm" onClick={onOpenModal} mt={2}>
        View Full Details
      </SolidActionButton>
    ) : null}
  </VStack>
)
